var _mask, _g, _mask2, _g2, _mask3, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGeneralActionMoreBlack = function SvgGeneralActionMoreBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "general-action-more-black_svg__a",
    width: 4,
    height: 4,
    x: 10,
    y: 10,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M10.5 10.5h3v3h-3z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#general-action-more-black_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4C4C4C",
    d: "M13.5 12a1.5 1.5 0 1 1-3-.001 1.5 1.5 0 0 1 3 .001"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "general-action-more-black_svg__b",
    width: 4,
    height: 4,
    x: 2,
    y: 10,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M2.25 10.5h3v3h-3z",
    clipRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#general-action-more-black_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4C4C4C",
    d: "M5.25 12a1.5 1.5 0 1 1-3-.001 1.5 1.5 0 0 1 3 .001"
  }))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "general-action-more-black_svg__c",
    width: 4,
    height: 4,
    x: 18,
    y: 10,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M18.75 10.5h3v3h-3z",
    clipRule: "evenodd"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#general-action-more-black_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4C4C4C",
    d: "M21.75 12a1.5 1.5 0 1 1-3-.001 1.5 1.5 0 0 1 3 .001"
  }))));
};
export default SvgGeneralActionMoreBlack;